export const TOOLS = {
  UNDO: 'Undo',
  REDO: 'Redo',
}
